import { DOCUMENT_BLOCK_TYPES, DOCUMENT_ALIGN } from "./schema";

/** Live preview / PDF source: mirrors `templates/autorizacao_gleba_loteamento.md`. */
const autorizacaoGlebaLoteamento = {
  id: "autorizacao-gleba-loteamento",

  blocks: [
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "AUTORIZAÇÃO PARA INTERMEDIAÇÃO DE LOTEAMENTO",
      align: DOCUMENT_ALIGN.LEFT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "AUTORIZADOR(ES) (PROPRIETÁRIO)",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{PROPRIETARIOS}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "AUTORIZADO(S) (INTERMEDIADOR)",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{INTERMEDIADOR}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "As partes acima identificadas firmam a presente AUTORIZAÇÃO PARA INTERMEDIAÇÃO DE NEGÓCIO IMOBILIÁRIO, que será regida pelas cláusulas abaixo, de forma clara e transparente.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "CLÁUSULAS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1) DO IMÓVEL",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.1) Imóvel inscrito sob matrícula nº {MATRICULA_IMOVEL} do {OFICIO_REGISTRO} Ofício de Registro de Imóveis da Comarca de {COMARCA_IMOVEL}, sendo um imóvel de {AREA_IMOVEL_HECTARES} hectares, no bairro {BAIRRO_IMOVEL}, município de {MUNICIPIO_IMOVEL}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2) DA AUTORIZAÇÃO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.1) O(s) proprietário(s) acima qualificados concedem ao AUTORIZADO(S), autorização expressa para divulgação do imóvel acima identificado, a fim de apresentá-lo a possíveis interessados na aquisição ou em parceria para implantação de parcelamento do solo na modalidade loteamento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.2) A presente autorização permite que o corretor apresente o imóvel ao mercado e encaminhe aos proprietários as propostas que vierem a surgir. Para isso, o corretor poderá realizar estudo do imóvel, veicular anúncios físicos ou virtuais, atender potenciais interessados, acompanhar visitas ao local e prestar todas as informações necessárias para a adequada avaliação das oportunidades de negociação.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "3) DA EXCLUSIVIDADE",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.1) O(s) proprietário(s) concedem ao corretor permissão para representar o imóvel nas negociações de venda ou nas tratativas destinadas à celebração de parceria para implantação de loteamento, nos termos do artigo 726 do Código Civil.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.2) A presente autorização é concedida em caráter de {EXCLUSIVIDADE}, para fins de intermediação de negociações envolvendo o imóvel descrito neste instrumento, observadas as disposições aqui previstas.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.3) O corretor poderá, sempre que considerar oportuno, firmar parcerias com outras imobiliárias ou corretores para ampliar as oportunidades de negócio, permanecendo, contudo, a condução das negociações centralizada no AUTORIZADO(S), assegurando maior organização, segurança e fluidez ao processo.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3.4) Eventuais comissões decorrentes dessas parcerias serão tratadas exclusivamente pelo corretor, sem qualquer responsabilidade financeira adicional ao(s) proprietário(s).",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "4) DO PRAZO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.1) A presente autorização terá prazo de {PRAZO_AUTORIZACAO} meses a contar da data de sua assinatura pelas partes.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.2) A autorização será prorrogada automaticamente por igual período, caso o(s) proprietário(s) assim desejem e não manifestem expressamente pedido de revogação.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "5) DA REMUNERAÇÃO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.1) A remuneração do corretor será de {PERCENTUAL_COMISSAO}% ({PERCENTUAL_COMISSAO_EXTENSO}), seja na hipótese de venda pura e simples do imóvel, caso em que o percentual incidirá sobre o valor da negociação, seja na hipótese de parceria para implantação de loteamento, situação em que o mesmo percentual incidirá sobre a quota ou percentual que vier a caber ao(s) proprietário(s) no contrato de parceria ou em qualquer outro instrumento firmado com a empresa loteadora.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.2) O corretor terá direito à remuneração prevista nesta autorização mesmo após o término ou revogação desta autorização, caso o negócio seja concluído com potencial adquirente ou parceiro por ele apresentado, nos termos do artigo 727 do Código Civil.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "6) DO VALOR DO IMÓVEL",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "6.1) Em caso de venda, o valor acordado entre os proprietários para venda do imóvel é de {VALOR_IMOVEL} ({VALOR_IMOVEL_EXTENSO}).",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "6.2) O valor acima também poderá ser utilizado como referência econômica e venal do imóvel para fins negociais, registrais, tributários ou contratuais, quando necessário.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "6.3) Em caso de recebimento de proposta ou forma de pagamento diversa do que foi acordado nesta autorização, as partes poderão, em comum acordo, delimitar novo valor ou novas condições para efetivação do negócio.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "7) DO PAGAMENTO DOS HONORÁRIOS EM CASO DE VENDA",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.1) Os honorários de corretagem pela venda pura e simples do imóvel serão pagos de uma só vez no momento da assinatura do contrato de compra e venda, contrato de cessão de direitos, compromisso de compra e venda ou, ainda, por ocasião da assinatura da escritura pública.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.2) Eventual pagamento em forma diversa da aqui ajustada deverá ser previamente acordado entre as partes.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "8) DOS HONORÁRIOS EM CASO DE PARCERIA PARA LOTEAMENTO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "8.1) Os honorários decorrentes de intermediação de parceria para loteamento serão adimplidos pelo(s) proprietário(s) após o registro do loteamento junto ao Registro de Imóveis competente.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "8.2) Os honorários poderão ser pagos em espécie ou mediante entrega de lotes equivalentes a {PERCENTUAL_COMISSAO}% ({PERCENTUAL_COMISSAO_EXTENSO}) do percentual que couber ao(s) proprietário(s) no contrato firmado com a empresa loteadora.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "9) DA RESPONSABILIDADE PELO PAGAMENTO DA COMISSÃO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.1) O(s) proprietário(s) são responsáveis pelo pagamento dos honorários de intermediação devidos ao AUTORIZADO(S), conforme percentuais previstos nesta autorização.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.2) As partes poderão ajustar, de comum acordo, que a comissão seja total ou parcialmente paga pelo comprador do imóvel ou pela empresa parceira na implantação do loteamento, hipótese em que tal ajuste deverá constar expressamente do instrumento contratual celebrado com o terceiro.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "10) DAS DISPOSIÇÕES GERAIS",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "10.1) Esta autorização não transfere ao corretor qualquer direito real sobre o imóvel, limitando-se exclusivamente à intermediação imobiliária e apresentação de propostas.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "10.2) O(s) proprietário(s) declaram possuir legitimidade para autorizar a presente intermediação e responsabilizam-se pelas informações prestadas sobre o imóvel.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "11) DO FORO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "11.1) Fica eleito o foro da Comarca de {COMARCA_FORO}, com renúncia de qualquer outro, por mais privilegiado que seja, para dirimir eventuais controvérsias oriundas deste instrumento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "ENCERRAMENTO",
    },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "POR ESTAREM DE ACORDO, assinam a presente autorização.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CIDADE_ASSINATURA}, {DATA_ASSINATURA}.",
      align: DOCUMENT_ALIGN.RIGHT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 3 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "AUTORIZADOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_PROPRIETARIOS}",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_PROPRIETARIOS}",
      contentFormat: "html",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "AUTORIZADO(S)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_INTERMEDIADOR}",
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "TESTEMUNHAS" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_TESTEMUNHAS}",
    },
  ],
};

export default autorizacaoGlebaLoteamento;
